import React from 'react';
import styled from 'styled-components';

const SplitSection = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 800px;
  
  > div {
    width: 50%;
  } 
  
  @media (max-width: 800px) {
    flex-direction: column;
    > div {
      width: auto;
    } 
  } 
`;

export default SplitSection;


// WEBPACK FOOTER //
// ./src/Components/SplitSection.js